import React from 'react';

export const IconImageBlack = () => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 4.03333V18.9667C19 19.2612 18.7612 19.5 18.4667 19.5H3.53333C3.23878 19.5 3 19.2612 3 18.9667V4.03333C3 3.73878 3.23878 3.5 3.53333 3.5H18.4667C18.7612 3.5 19 3.73878 19 4.03333Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 4.03333V18.9667C19 19.2612 18.7612 19.5 18.4667 19.5H3.53333C3.23878 19.5 3 19.2612 3 18.9667V4.03333C3 3.73878 3.23878 3.5 3.53333 3.5H18.4667C18.7612 3.5 19 3.73878 19 4.03333Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.0556L9.22222 12.3889L19 16.8334"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.0556L9.22222 12.3889L19 16.8334"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5556 9.7223C13.5737 9.7223 12.7778 8.92637 12.7778 7.94453C12.7778 6.96269 13.5737 6.16675 14.5556 6.16675C15.5375 6.16675 16.3334 6.96269 16.3334 7.94453C16.3334 8.92637 15.5375 9.7223 14.5556 9.7223Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5556 9.7223C13.5737 9.7223 12.7778 8.92637 12.7778 7.94453C12.7778 6.96269 13.5737 6.16675 14.5556 6.16675C15.5375 6.16675 16.3334 6.96269 16.3334 7.94453C16.3334 8.92637 15.5375 9.7223 14.5556 9.7223Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
